import React from 'react';
import TableRow from './TableRow';

const TableBody = ({ users }) => {
    const rows = users.map(user => <TableRow key={user.id} {...user} />);
    return <tbody>{rows}</tbody>;
};

export default TableBody;


// WEBPACK FOOTER //
// ./src/components/Pages/Users/TableBody.js